const ESC_KEY_CODE = 27;
const ACTIVE = 'active';
const POPUP_BASE_ID = 'base_popup_and_spinner_wrapper';

function getValidatedFunction(fn) {
  return function () {
    if (fn !== undefined && typeof fn === 'function') {
      fn();
    }
  };
}

/**
 * @param {String} config.targetPopupSelector
 * @param {Boolean} config.closeOnEsc
 * @param {String||undefined} config.openButtonSelector
 * @param {String||undefined} config.closeButtonSelector
 * @param {Function||undefined} config.beforeOpen
 * @param {Function||undefined} config.afterOpen
 * @param {Function||undefined} config.beforeClose
 * @param {Function||undefined} config.afterClose
 */
function Popup(config) {
  this.scrollTop = 0;
  this.targetPopupSelector = config.targetPopupSelector;
  this.$openButtons = $(config.openButtonSelector);
  this.$closeButtons = $(config.closeButtonSelector);
  this.beforeOpen = getValidatedFunction(config.beforeOpen);
  this.afterOpen = getValidatedFunction(config.afterOpen);
  this.beforeClose = getValidatedFunction(config.beforeClose);
  this.afterClose = getValidatedFunction(config.afterClose);
  this.init(config);
}

Popup.prototype = {
  init({ closeOnEsc = true }) {
    this.popupBase = document.getElementById(POPUP_BASE_ID);
    this.movePopupToPopupBase();
    this.popup = document.querySelector(this.targetPopupSelector);
    this.attachEventHandlers(closeOnEsc);
  },

  movePopupToPopupBase() {
    const popup = document.querySelector(this.targetPopupSelector);
    if (!popup) {
      return;
    }
    const parent = popup.parentNode;
    if (parent.id !== POPUP_BASE_ID && this.popupBase !== null) {
      this.popupBase.appendChild(popup);
    }
  },

  attachEventHandlers(closeOnEsc) {
    const _this = this;
    if (this.$openButtons.length > 0) {
      this.$openButtons.on('click', _this.open.bind(_this));
    }
    if (this.$closeButtons.length > 0) {
      this.$closeButtons.on('click', _this.close.bind(_this));
    }

    if (closeOnEsc) {
      document.addEventListener('keydown', (event = window.event) => {
        if (event.keyCode === ESC_KEY_CODE && _this.popup.classList.contains(ACTIVE)) {
          _this.close();
        }
      });
    }
  },

  open() {
    if (!this.popup) {
      return;
    }
    this.beforeOpen();
    this.popup.classList.add(ACTIVE);
    this.afterOpen();
  },

  close() {
    if (!this.popup) {
      return;
    }
    this.beforeClose();
    this.popup.classList.remove(ACTIVE);
    this.afterClose();
  },
};

export default Popup;



// WEBPACK FOOTER //
// ./common/popup.lib.js